module.exports = __webpack_public_path__ + "assets/img/config-table-9a196d99.png";